/* eslint-disable react-hooks/exhaustive-deps */
import { Card, CardBody } from '@components/card/card';
import Select from 'react-select';

import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Breadcrumb from '@components/Shared/Breadcrumb';
import useGetEquipmentsList from '@hooks/FLeet/useGetEquipmentsList';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { EquipmentsWorkOrderSchema } from '@pages/ValidationForm/validationSchema';
import { InsertEquipmentsWorkOrder } from '@store/FLEET/EquipmentsWorkOrder/equipmentsworkorderSlice';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetFleetRequestType } from '@store/Lookup/lookupSlice';
import { GetNtxPeoplesList } from '@store/NTX/Peoples/peoplesSlice';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Lines from './Lines';
import PersonLines from './PersonLines';
import NeatixModal from '@components/Modal/NeatixModal';
import { getOrganization } from '@store/HR/Organizations/organizationSlice';
import {
  GetEquipmentsWorkRequestsById,
  resetEquipmentsWorkRequestState
} from '@store/FLEET/EquipmentsWorkRequests/equipmentsWorkRequestSlice';

const AddWorkOrder = () => {
  const [tempWorkshopId, setTempWorkshopId] = useState(''); // Temporary state for workshopId
  const [tempSupplierId, setTempSupplierId] = useState(''); // Temporary state for supplierId
  const [showModal, setShowModal] = useState(true);
  const Navigate = useNavigate();
  const { requestId } = useParams();

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(GetNtxPeoplesList(''));
    dispatch(GetFleetRequestType());

    if (requestId) {
      dispatch(GetEquipmentsWorkRequestsById(requestId));
    }

    return () => {
      dispatch(resetEquipmentsWorkRequestState());
    };
  }, []);

  const { EquipmentsWorkRequestById: RequestData } = useAppSelector(state => state.EquipmentsWorkRequest);

  // console.log('RequestData', RequestData);

  const { OrganizationWorkShop } = useGetOrganizations();
  const { FleetRequestType } = useAppSelector(state => state.Lookup);
  const { OptionsEquipments } = useGetEquipmentsList();
  const { PeoplesList } = useAppSelector(state => state.Peoples);

  const formik = useFormik({
    initialValues: {
      //   fleetEquipmentsWorkRequestsId: Id || null,
      //   fleetEquipmentsId: fleetEquipmentsId || null,
      fleetEquipmentsWorkRequestsId: RequestData ? RequestData.id : null,
      fleetEquipmentsId: RequestData ? RequestData.fleetEquipmentsId : null,
      orderCode: '',
      orderType: RequestData ? RequestData.requestType : '',
      odometer: RequestData ? RequestData.odometer : 0,
      note: RequestData ? RequestData.description : '',
      organizationId: null,
      closePersonId: null,
      dateCompletion: null,
      isInternal: '1', // boolean
      startDateSugg: '',
      endDateSugg: '',
      totalItems: 0,
      totalAsset: 0,
      otherAmounts: 0,
      totalBudget: 0,
      supplierId: '',
      workshopId: '',
      startDateExecution: null,
      endDateExecution: null,
      noteCompletion: '',
      totalItemsActual: 0,
      totalAssetActual: 0,
      otherAmountsActual: 0,
      totalBudgetActual: 0,
      equipmentsWorkOrderItemList: [
        {
          itemId: null,
          uom: null,
          qty: 0,
          unitCost: 0,
          totalCost: 0,
          notes: ''
        }
      ],
      equipmentsWorkOrderPersonList: [
        {
          personId: null,
          notes: ''
        }
      ]
    },
    enableReinitialize: true,
    validationSchema: EquipmentsWorkOrderSchema(t),
    onSubmit: values => {
      dispatch(
        InsertEquipmentsWorkOrder({
          fleetEquipmentsWorkRequestsId: values.fleetEquipmentsWorkRequestsId,
          fleetEquipmentsId: values.fleetEquipmentsId,
          orderCode: values.orderCode,
          orderType: values.orderType,
          note: values.note,
          odometer: Number(values.odometer ?? 0),
          organizationId: values.organizationId,
          closePersonId: values.closePersonId,
          dateCompletion: values.dateCompletion,
          isInternal: values.isInternal === '1' ? true : false,
          startDateSugg: values.startDateSugg, //
          endDateSugg: values.endDateSugg, //

          totalItems: Number(values.totalItems ?? 0),
          totalAsset: Number(values.totalAsset ?? 0),
          otherAmounts: Number(values.otherAmounts ?? 0),
          totalBudget: Number(values.totalBudget ?? 0),
          supplierId: values.isInternal === '0' ? values.supplierId : null,
          workshopId: values.isInternal === '1' ? values.workshopId : null,
          startDateExecution: values.startDateExecution,
          endDateExecution: values.endDateExecution,
          noteCompletion: values.noteCompletion,
          totalItemsActual: values.totalItemsActual,
          totalAssetActual: values.totalAssetActual,
          otherAmountsActual: values.otherAmountsActual,
          totalBudgetActual: values.totalBudgetActual,

          equipmentsWorkOrderItemList:
            values.isInternal === '0'
              ? []
              : values.equipmentsWorkOrderItemList.map(m => ({
                  itemId: m.itemId,
                  uom: m.uom,
                  qty: Number(m.qty),
                  unitCost: Number(m.unitCost),
                  totalCost: Number(m.totalCost),
                  notes: m.notes
                })),

          equipmentsWorkOrderPersonList:
            values.isInternal === '0'
              ? []
              : values.equipmentsWorkOrderPersonList.map(m => ({
                  personId: m.personId || null,
                  notes: m.notes || ''
                }))
        })
      )
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            Navigate('/FLEET/WorkOrder', { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });
  const { values, setFieldValue, errors } = formik;

  // console.log(errors);

  useEffect(() => {
    const fetchWorkshopData = async () => {
      try {
        const result = await dispatch(getOrganization(values.workshopId as any)).unwrap();

        // هنا يمكنك الوصول إلى قيمة الـ value من parameters
        const inventoryParam = result.parameters.find((param: any) => param.type === 'Inventory');

        if (inventoryParam) {
          setFieldValue('organizationId', inventoryParam.value);
          //   console.log('Inventory Value:', inventoryParam.value);
          // يمكنك هنا تحديث state أو تنفيذ أي إجراء آخر بالبيانات
        }
      } catch (error) {
        console.error('Failed to fetch workshop data:', error);
        // معالجة الأخطاء هنا
      }
    };

    if (values.workshopId) {
      fetchWorkshopData();
    }
  }, [dispatch, values.workshopId]);

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'MaintenanceOrders',
              link: '/FLEET/Maintenance/MaintenanceOrder'
            },

            {
              name: 'AddWorkOrder',
              link: null
            }
          ]}
          PageName='AddWorkOrder'
          subtitle={Object.keys(RequestData || {}).length > 0 ? ` رقم الطلب : ${RequestData?.requestCode}` : ''}
        />
      </div>

      <Card>
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <div className=' d-flex justify-content-between bg-theme bg-opacity-15 mb-3'>
              <h5 className={`fw-bold border-start  border-4 border-theme p-2 m-0 d-flex align-items-center`}>
                <i className='fas fa-info-circle fa-sm me-2'></i>
                {t('BasicInformation')}
              </h5>
            </div>

            <div className='row'>
              {/* الصف الأول: المعلومات الأساسية */}
              <div className='col-xl-4'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Vehicle')}</label>

                  <Select
                    isDisabled={Object.keys(RequestData || {}).length > 0}
                    classNamePrefix='react-select'
                    className='w-100  '
                    // isLoading={loading}
                    isSearchable={true}
                    isClearable
                    // options={OptionsEquipments.filter(f => !f.IsVacant)}
                    options={OptionsEquipments}
                    value={OptionsEquipments.find(f => f.value === values.fleetEquipmentsId)}
                    onChange={(option: any) => {
                      setFieldValue('fleetEquipmentsId', option === null ? null : option.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                    }}
                    formatOptionLabel={option => {
                      const isRTL = i18n.language === 'ar';
                      const imgSrc = option.PathImage || '/assets/img/Image/NoImg2.ico';

                      return (
                        <div className='d-flex justify-content-between align-items-center'>
                          <div className='d-flex align-items-center'>
                            <img
                              src={imgSrc}
                              alt={option.label}
                              onError={(e: any) => {
                                e.target.onerror = null;
                                e.target.src = '/assets/img/Image/NoImg2.ico';
                              }}
                              style={{
                                width: '40px',
                                height: '40px',
                                objectFit: 'cover',
                                marginLeft: isRTL ? '10px' : '0',
                                marginRight: isRTL ? '0' : '10px',
                                borderRadius: '4px'
                              }}
                            />
                            <div>{option.label}</div>
                          </div>
                        </div>
                      );
                    }}
                  />
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('TypeMaintenance')}</label>
                  <Form.Select
                    disabled={Object.keys(RequestData || {}).length > 0}
                    className='form-select'
                    name='orderType'
                    onChange={formik.handleChange}
                    value={formik.values.orderType || ''}
                    isInvalid={!!(formik.touched.orderType && formik.errors.orderType)}
                  >
                    <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                    {FleetRequestType?.flatMap((item: any) =>
                      item.list?.map((list: any, idx: any) => (
                        <option key={idx} value={list.lookupCode}>
                          {i18n.language === 'ar' ? list.meaning2 : list.meaning}
                        </option>
                      ))
                    )}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>{formik.errors.orderType}</Form.Control.Feedback>
                </div>
              </div>

              <div className='col-xl-2'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('InternalOrExternal')}</label>
                  <Form.Select
                    disabled
                    className='form-select'
                    name='isInternal'
                    onChange={formik.handleChange}
                    value={formik.values.isInternal || ''}
                    isInvalid={!!(formik.touched.isInternal && formik.errors.isInternal)}
                  >
                    <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                    <option value='1'>{t('Internal')}</option>
                    <option value='0'>{t('External')}</option>
                  </Form.Select>
                </div>
              </div>

              {/* الصف الثاني: الجهة المنفذة (تظهر حسب الاختيار) */}
              {formik.values.isInternal === '1' && (
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Workshop')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='workshopId'
                      onChange={formik.handleChange}
                      value={formik.values.workshopId}
                      isInvalid={!!(formik.touched.workshopId && formik.errors.workshopId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {OrganizationWorkShop?.filter((f: any) => f.type === '160')?.map((item: any, idx: any) => (
                        <option key={idx} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
              )}

              {formik.values.isInternal === '0' && (
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Supplier')}</label>
                    <Form.Select
                      disabled
                      className='form-select'
                      name='supplierId'
                      onChange={formik.handleChange}
                      value={formik.values.supplierId || ''}
                      isInvalid={!!(formik.touched.supplierId && formik.errors.supplierId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PeoplesList?.filter(f => f.typeCode === 'SUPPLIERS')?.map((item, idx) => (
                        <option key={idx} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
              )}

              {/* الصف الثالث: التوقيت والمبلغ */}
              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Odometer')}</label>
                  <div className='input-group'>
                    <Form.Control
                      className='form-control'
                      type='number'
                      name='odometer'
                      onChange={formik.handleChange}
                      value={formik.values.odometer || 0}
                      isInvalid={!!(formik.touched.odometer && formik.errors.odometer)}
                    />
                    <span className='input-group-text'>{t('KM')}</span>
                  </div>
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Expected_start_date')}</label>
                  <Form.Control
                    className='form-control'
                    type='date'
                    name='startDateSugg'
                    onChange={formik.handleChange}
                    value={formik.values.startDateSugg}
                    isInvalid={!!(formik.touched.startDateSugg && formik.errors.startDateSugg)}
                  />
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Expected_end_date')}</label>
                  <Form.Control
                    className='form-control'
                    // type='datetime-local'
                    type='date'
                    name='endDateSugg'
                    onChange={formik.handleChange}
                    value={formik.values.endDateSugg}
                    isInvalid={!!(formik.touched.endDateSugg && formik.errors.endDateSugg)}
                  />
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Other_amounts')}</label>
                  <div className='input-group'>
                    <Form.Control
                      className='form-control'
                      type='number'
                      name='otherAmounts'
                      onChange={formik.handleChange}
                      value={formik.values.otherAmounts}
                      isInvalid={!!(formik.touched.otherAmounts && formik.errors.otherAmounts)}
                    />
                    <span className='input-group-text'>{t('SAR')}</span>
                  </div>
                </div>
              </div>

              <div className='col-xl-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Note')}</label>
                  <Form.Control
                    className='form-control'
                    as='textarea'
                    rows={1}
                    name='note'
                    onChange={formik.handleChange}
                    value={formik.values.note}
                  />
                </div>
              </div>
            </div>

            {values.isInternal !== '0' && (
              <>
                <hr className='my-4' />
                {values.organizationId ? (
                  <div className='mb-4'>
                    <div className='row bg-inverse bg-opacity-5'>
                      <Lines formik={formik} />
                      {formik.errors.equipmentsWorkOrderItemList?.length && (
                        <div className='text-danger'> * {t('Required')} </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className='alert alert-warning mb-4'>
                    <i className='fas fa-exclamation-triangle me-2'></i>
                    {t('WorkshopNotLinked')}
                  </div>
                )}

                <hr className='my-4' />
                <div className='mb-4'>
                  <div className='row   bg-inverse bg-opacity-5  '>
                    <PersonLines formik={formik} />
                    {formik.errors.equipmentsWorkOrderPersonList?.length && (
                      <div className='text-danger'> * {t('Required')} </div>
                    )}
                  </div>
                </div>
              </>
            )}

            <div className='text-center mt-4'>
              <div className='d-flex justify-content-center gap-2'>
                <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1  '>
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-save fa-lg fa-fw me-2'></i>
                  )}
                  {t('Add')}
                </button>
                <button
                  type='button'
                  className='btn btn-lg  btn-default mb-1  '
                  onClick={() => Navigate('/FLEET/WorkOrder', { replace: true })}
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </Form>
        </CardBody>
      </Card>

      <NeatixModal
        show={showModal}
        setShow={setShowModal}
        size='md'
        bodyClassName='p-0'
        centered
        showHeader={false}
        keyboard={false}
        backdrop={true}
      >
        <Card>
          <CardBody>
            <div className='card-header text-center bg-theme bg-opacity-15 py-3 mb-3'>
              <h5 className='mb-1'>{t('OrderTypeSelection')}</h5>
              <p className='text-muted small mb-0'>{t('OrderTypeDescription')}</p>
            </div>
            <div className='row'>
              <div className='col-xl-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('OrderType')}</label>
                  <div className='d-flex gap-1'>
                    <button
                      type='button'
                      className={`btn btn-sm px-4   ${
                        formik.values.isInternal === '1' ? 'btn-theme' : 'btn-outline-secondary'
                      }`}
                      onClick={() => {
                        formik.setFieldValue('isInternal', '1');
                        setTempSupplierId(''); // Reset supplierId when switching to internal
                      }}
                    >
                      {t('Internal')}
                    </button>
                    <button
                      type='button'
                      className={`btn btn-sm px-4  ${
                        formik.values.isInternal === '0' ? 'btn-theme' : 'btn-outline-secondary'
                      }`}
                      onClick={() => {
                        formik.setFieldValue('isInternal', '0');
                        setTempWorkshopId(''); // Reset workshopId when switching to external
                      }}
                    >
                      {t('External')}
                    </button>
                  </div>
                  {formik.touched.isInternal && formik.errors.isInternal && (
                    <div className='text-danger small mt-1'>{formik.errors.isInternal}</div>
                  )}
                </div>
              </div>

              {formik.values.isInternal === '1' && (
                <div className='col-xl-12'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Workshop')}</label>
                    <Form.Select
                      className='form-select'
                      value={tempWorkshopId}
                      onChange={e => setTempWorkshopId(e.target.value)}
                      isInvalid={!!(formik.touched.workshopId && formik.errors.workshopId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {OrganizationWorkShop?.filter((f: any) => f.type === '160')?.map((item: any, idx: any) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{formik.errors.workshopId}</Form.Control.Feedback>
                  </div>
                </div>
              )}
              {formik.values.isInternal === '0' && (
                <div className='col-xl-12'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Supplier')}</label>
                    <Form.Select
                      className='form-select'
                      value={tempSupplierId}
                      onChange={e => setTempSupplierId(e.target.value)}
                      isInvalid={!!(formik.touched.supplierId && formik.errors.supplierId)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {PeoplesList?.filter(f => f.typeCode === 'SUPPLIERS')?.map((item, idx) => (
                        <option key={++idx} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type='invalid'>{formik.errors.supplierId}</Form.Control.Feedback>
                  </div>
                </div>
              )}
            </div>

            <div className='row'>
              {/* Confirm Button */}
              <div className='col-6'>
                <button
                  type='button'
                  className='btn btn-lg btn-theme w-100 rounded-0'
                  onClick={() => {
                    if (formik.values.isInternal === '1') {
                      formik.setFieldValue('workshopId', tempWorkshopId);
                      formik.setFieldValue('supplierId', ''); // Clear supplierId
                    } else if (formik.values.isInternal === '0') {
                      formik.setFieldValue('supplierId', tempSupplierId);
                      formik.setFieldValue('workshopId', ''); // Clear workshopId
                    }
                    setShowModal(false);
                  }}
                  disabled={
                    (formik.values.isInternal === '1' && !tempWorkshopId) ||
                    (formik.values.isInternal === '0' && !tempSupplierId)
                  }
                >
                  <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
                  {t('ConfirmSelection')}
                </button>
              </div>

              {/* Cancel Button */}
              <div className='col-6'>
                <button
                  type='button'
                  className='btn btn-lg btn-default w-100 rounded-0'
                  onClick={() => Navigate('/FLEET/WorkOrder', { replace: true })}
                >
                  <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </NeatixModal>
    </>
  );
};

export default AddWorkOrder;
